import React, { useEffect, useMemo, useState } from "react";
import { FaTimes } from "react-icons/fa";
import BtnGuardar from "../../../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../../../components/buttons/BtnCancelar";
import apiRoutes from "../../../../../api/apiRoutes";
import { appFetchJson } from "../../../../../utils/http";
import SelectDepartamento from "../../../../../components/select/SelectDepartamento"; 

export default function EditarCiudad({ initial, onClose = () => {}, onSaved = () => {} }) {
  const id = useMemo(() => initial?.id ?? null, [initial]);
  const [nombre, setNombre] = useState(initial?.nombre || "");
  const [codigo, setCodigo] = useState(initial?.codigo || "");
  const [nombrePais, setNombrePais] = useState(initial?.nombrePais || "");
  const [departamento, setDepartamento] = useState(
    initial?.departamentoId ? { id: initial.departamentoId, nombre: initial.departamentoNombre || "" } : null
  );
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const isValid = nombre.trim() !== "" && codigo.trim() !== "";
  const changed = useMemo(() => {
    return (
      nombre !== (initial?.nombre || "") ||
      codigo !== (initial?.codigo || "") ||
      nombrePais !== (initial?.nombrePais || "") ||
      (departamento?.id ?? null) !== (initial?.departamentoId ?? null)
    );
  }, [nombre, codigo, nombrePais, departamento, initial]);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const handleSave = async () => {
    if (!id || !changed || !isValid || saving) return;
    setSaving(true);
    setError("");
    try {
      const payload = {
        nombre: nombre.trim(),
        codigo: codigo.trim(),
        nombrePais: nombrePais.trim() || undefined,
        departamentoId: departamento?.id ?? null,
      };
      const updated = await appFetchJson(apiRoutes.ciudades.update(id), {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      onSaved(updated);
      onClose();
    } catch (e) {
      console.error("Error actualizando ciudad:", e);
      setError(e?.message || "Error al actualizar la ciudad.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel-lg" onClick={e => e.stopPropagation()}>
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Editar Ciudad</h2>
          <button className="modal-close-x" onClick={onClose}><FaTimes /></button>
        </div>
        <div className="modal-body">
          <p className="text-gray-600 mb-4 italic">Modifique los datos de la ciudad</p>
          {error && <div className="text-red-600 mb-3 font-medium">{error}</div>}
          <div className="space-y-4">
            <div><label className="form-label">Nombre *</label><input type="text" className="input" value={nombre} onChange={e => setNombre(e.target.value)} placeholder="Nombre de la ciudad" /></div>
            <div><label className="form-label">Código *</label><input type="text" className="input" value={codigo} onChange={e => setCodigo(e.target.value)} placeholder="Código de la ciudad" /></div>
            <div><label className="form-label">País</label><input type="text" className="input" value={nombrePais} onChange={e => setNombrePais(e.target.value)} placeholder="País" /></div>
            <div><label className="form-label">Departamento</label><SelectDepartamento value={departamento} onChange={setDepartamento} /></div>
          </div>
        </div>
        <div className="modal-footer">
          <div className="btn-row">
            <BtnGuardar label="Guardar" isValid={isValid && changed} saving={saving} onClick={handleSave} />
            <BtnCancelar onClick={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
}